var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.projectManagers},on:{"change":function($event){return _vm.setProjectManager(_vm.projectId, _vm.value && _vm.value.value)}},model:{value:(_vm.value.value),callback:function ($$v) {_vm.$set(_vm.value, "value", $$v)},expression:"value.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }